/* istanbul ignore file */
import { BasicQueryStringUtils } from '@openid/appauth';

export class NoHashQueryStringUtils extends BasicQueryStringUtils {
  parse(input: any, useHash: any) {
    return super.parse(input, false /* nerver use hash */);
  }
}
